<div class="dialog-container page-container">
    <div class="popup-header">
        <div class="header-left">
            <div class="header-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                        stroke-width="1"
                        d="M15 19c0-2.21-2.686-4-6-4s-6 1.79-6 4m16-3v-3m0 0v-3m0 3h-3m3 0h3M9 12a4 4 0 1 1 0-8a4 4 0 0 1 0 8" />
                </svg>
            </div>
            <div class="header-text">
                <h2 class="header-title">{{ popupTitle }}</h2>
                <p *ngIf="popupSubtitle" class="header-subtitle">{{ popupSubtitle }}</p>
            </div>
        </div>

        <button mat-icon-button class="mat-dialog-close" (click)="closeDialog()">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
            </svg>
        </button>
    </div>
    <section mat-dialog-content class="mt-4">
        <form [formGroup]="memberform">
            <div class="form-container">
                <!-- Regular Member Form (for non-DISTRIBUTOR roles) -->
                <div *ngIf="userRole === enumRole.DISTRIBUTOR || userRole ==='PROVIDER'  || userRole ==='INSURER' " >
                    <div class="form-row ">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>First Name</mat-label>
                            <input type="text" matInput required formControlName="firstName">
                            <mat-error *ngIf="memberform.get('firstName')?.hasError('required')">
                                First Name is required
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Last Name</mat-label>
                            <input type="text" matInput required formControlName="lastName">
                            <mat-error *ngIf="memberform.get('lastName')?.hasError('required')">
                                Last Name is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Date of Birth</mat-label>
                            <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth" [max]="today" placeholder="dd-mm-yyyy"
                                required>
                            <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                            <mat-datepicker #dobPicker></mat-datepicker>

                            <mat-error *ngIf="memberform.get('dateOfBirth')?.hasError('required')">
                                Date of Birth is required
                            </mat-error>
                            <mat-error *ngIf="memberform.get('dateOfBirth')?.errors?.['matDatepickerParse']?.text">
                                Invalid date format
                            </mat-error>
                        </mat-form-field>


                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Gender</mat-label>
                            <mat-select formControlName="gender" required>
                                <mat-option value="Male">Male</mat-option>
                                <mat-option value="Female">Female</mat-option>
                                <mat-option value="Prefer not to say">Prefer not to say</mat-option>
                            </mat-select>
                            <mat-error *ngIf="memberform.get('gender')?.hasError('required')">
                                Gender is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Email</mat-label>
                            <input type="email" matInput required formControlName="email">
                            <mat-error *ngIf="memberform.get('email')?.hasError('required')">
                                Email is required
                            </mat-error>
                            <mat-error *ngIf="memberform.get('email')?.hasError('email')">
                                Invalid email address
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Phone</mat-label>
                            <input matInput formControlName="phone" required placeholder="+44 7123 456789">
                            <mat-error *ngIf="memberform.get('phone')?.hasError('required')">
                                Phone Number is required
                            </mat-error>
                            <mat-error *ngIf="memberform.get('phone')?.hasError('pattern')">
                                Invalid phone number
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-row">

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Address</mat-label>
                            <input type="text" matInput required formControlName="address">
                            <mat-error *ngIf="memberform.get('address')?.hasError('required')">
                                Address is required
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Years of exp</mat-label>
                            <input matInput formControlName="yearsOfExperience">
                        </mat-form-field>
                    </div>

                      <div class="form-row">

                    <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Active Start Date</mat-label>
                        <input matInput [matDatepicker]="startDatePicker" formControlName="activeStartDate" [min]="today">
                        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #startDatePicker></mat-datepicker>
                        <mat-error *ngIf="memberform.get('activeStartDate')?.hasError('required')">
                            Active Start Date is required
                        </mat-error>
                    </mat-form-field>

                     <mat-form-field appearance="outline" class="form-field">
                        <mat-label>Active End Date (Optional)</mat-label>
                        <input matInput [matDatepicker]="endDatePicker" formControlName="activeEndDate">
                        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #endDatePicker></mat-datepicker>
                        <mat-error *ngIf="memberform.get('activeEndDate')?.hasError('invalidEndDate')">
                            End date must be after start date
                        </mat-error>
                    </mat-form-field>
                </div>
                </div>
                 

                <!-- Agent Form (for DISTRIBUTOR role) -->
                <!-- <div *ngIf="userRole == 'PREVIOUS'">
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>FCA Reference Number (FRN)</mat-label>
                            <input type="text" matInput required formControlName="fcaReferenceNumber"
                                placeholder="Enter FCA reference number">
                            <mat-error *ngIf="memberform.get('fcaReferenceNumber')?.hasError('required')">
                                FCA Reference Number is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Name</mat-label>
                            <input type="text" matInput required formControlName="name" placeholder="Enter agent name">
                            <mat-error *ngIf="memberform.get('name')?.hasError('required')">
                                Name is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Email</mat-label>
                            <input type="email" matInput required formControlName="email"
                                placeholder="Enter email address">
                            <mat-error *ngIf="memberform.get('email')?.hasError('required')">
                                Email is required
                            </mat-error>
                            <mat-error *ngIf="memberform.get('email')?.hasError('email')">
                                Invalid email address
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Phone</mat-label>
                            <input matInput formControlName="phone" required placeholder="+44 7123 456789">
                            <mat-error *ngIf="memberform.get('phone')?.hasError('required')">
                                Phone Number is required
                            </mat-error>
                            <mat-error *ngIf="memberform.get('phone')?.hasError('pattern')">
                                Invalid phone number
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="form-row">
                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Active Start Date</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" formControlName="activeStartDate"
                                [max]="today" required>
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                            <mat-error *ngIf="memberform.get('activeStartDate')?.hasError('required')">
                                Active Start Date is required
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field">
                            <mat-label>Active End Date</mat-label>
                            <input matInput [matDatepicker]="endDatePicker" formControlName="activeEndDate"
                                [min]="memberform.get('activeStartDate')?.value">
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                            <mat-error *ngIf="memberform.get('activeEndDate')?.hasError('required')">
                                Active End Date is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    @if(userRole == 'DISTRIBUTOR'){
                    <span class="fs-14 fw-500" *ngIf="addedInsurerList.length > 0">
                        * Map the insurer you want to send requests for.
                    </span>

                    <span class="fs-14 text-danger" *ngIf="addedInsurerList.length == 0">
                        * Please map the evidence providers before create the request.
                    </span>

                    <div class="provider-selection">
                        <div class="provider-card" *ngFor="let insurer of addedInsurerList; let i = index"
                            [class.selected]="selectedInsurerId === insurer.id"
                            (click)="selectInsurer(insurer.id)">
                            <div class="patient-avatar">
                                <ng-container *ngIf="insurer.imgLogoUrl; else defaultIcon">
                                    <img [src]="insurer.imgLogoUrl" alt="{{insurer.userId}}" />
                                </ng-container>

                                <ng-template #defaultIcon>
                                    <span class="icon-btn" style="padding: 12px;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                            viewBox="0 0 256 256">
                                            <path fill="#757474"
                                                d="M248 212h-12v-84a12 12 0 0 0-12-12h-60V48a12 12 0 0 0-12-12H56a12 12 0 0 0-12 12v164H32a4 4 0 0 0 0 8h216a4 4 0 0 0 0-8m-24-88a4 4 0 0 1 4 4v84h-64v-88ZM52 48a4 4 0 0 1 4-4h96a4 4 0 0 1 4 4v164h-24v-52a4 4 0 0 0-4-4H80a4 4 0 0 0-4 4v52H52Zm72 164H84v-48h40ZM76 96a4 4 0 0 1 4-4h20V72a4 4 0 0 1 8 0v20h20a4 4 0 0 1 0 8h-20v20a4 4 0 0 1-8 0v-20H80a4 4 0 0 1-4-4"
                                                stroke-width="1.5" stroke="#757474" />
                                        </svg>
                                    </span>

                                </ng-template>
                            </div>

                            <div class="provider-info">
                                <h4>{{ insurer.userId }}  </h4>
                                <p><span class="gray-text fs-12">Admin Insurer :</span> {{ insurer.name }}</p>
                            </div>
                        </div>
                    </div>
                    }
                </div> -->
            </div>
            @if(userAccess == enumRole.ADMIN_INSURER){
            <span class="fs-14 fw-500" *ngIf="addedProvidersList.length > 0">
                * Map the providers you want to send requests for.
            </span>

            <span class="fs-14 text-danger" *ngIf="addedProvidersList?.length == 0">
                * Please map the evidence providers before create the request.
            </span>

            <div class="provider-selection">
                <div class="provider-card" *ngFor="let provider of addedProvidersList; let i = index"
                    [class.selected]="selectedProviderId === provider.id"
                    (click)="selectProvider(provider.id)">
                    <div class="patient-avatar">
                        <ng-container *ngIf="provider.imgLogoUrl; else defaultIcon">
                            <img [src]="provider.imgLogoUrl" alt="{{provider.id}}" />
                        </ng-container>

                        <ng-template #defaultIcon>
                            <span class="icon-btn" style="padding: 12px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256">
                                    <path fill="#757474"
                                        d="M248 212h-12v-84a12 12 0 0 0-12-12h-60V48a12 12 0 0 0-12-12H56a12 12 0 0 0-12 12v164H32a4 4 0 0 0 0 8h216a4 4 0 0 0 0-8m-24-88a4 4 0 0 1 4 4v84h-64v-88ZM52 48a4 4 0 0 1 4-4h96a4 4 0 0 1 4 4v164h-24v-52a4 4 0 0 0-4-4H80a4 4 0 0 0-4 4v52H52Zm72 164H84v-48h40ZM76 96a4 4 0 0 1 4-4h20V72a4 4 0 0 1 8 0v20h20a4 4 0 0 1 0 8h-20v20a4 4 0 0 1-8 0v-20H80a4 4 0 0 1-4-4"
                                        stroke-width="1.5" stroke="#757474" />
                                </svg>
                            </span>

                        </ng-template>
                    </div>

                    <div class="provider-info">
                        <h4>{{ provider.tradingName }}</h4>
                        <p><span class="gray-text fs-12">OrganisationId :</span> {{ provider.orgId}}</p>
                    </div>
                </div>
            </div>
            }
            @else if (userRole=='DISTRIBUTOR') {

                <span class="fs-14 fw-500" *ngIf="addedInsurerList.length > 0">
                        * Map the insurer you want to send requests for.
                    </span>

                    <span class="fs-14 text-danger" *ngIf="addedInsurerList.length == 0">
                        * Please map the evidence providers before create the request.
                    </span>

                    <div class="provider-selection">
                        <div class="provider-card" *ngFor="let insurer of addedInsurerList; let i = index"
                            [class.selected]="selectedInsurerId === insurer.id"
                            (click)="selectInsurer(insurer.id)">
                            <div class="patient-avatar">
                                <ng-container *ngIf="insurer.imgLogoUrl; else defaultIcon">
                                    <img [src]="insurer.imgLogoUrl" alt="{{insurer.userId}}" />
                                </ng-container>

                                <ng-template #defaultIcon>
                                    <span class="icon-btn" style="padding: 12px;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                            viewBox="0 0 256 256">
                                            <path fill="#757474"
                                                d="M248 212h-12v-84a12 12 0 0 0-12-12h-60V48a12 12 0 0 0-12-12H56a12 12 0 0 0-12 12v164H32a4 4 0 0 0 0 8h216a4 4 0 0 0 0-8m-24-88a4 4 0 0 1 4 4v84h-64v-88ZM52 48a4 4 0 0 1 4-4h96a4 4 0 0 1 4 4v164h-24v-52a4 4 0 0 0-4-4H80a4 4 0 0 0-4 4v52H52Zm72 164H84v-48h40ZM76 96a4 4 0 0 1 4-4h20V72a4 4 0 0 1 8 0v20h20a4 4 0 0 1 0 8h-20v20a4 4 0 0 1-8 0v-20H80a4 4 0 0 1-4-4"
                                                stroke-width="1.5" stroke="#757474" />
                                        </svg>
                                    </span>

                                </ng-template>
                            </div>

                            <div class="provider-info">
                                <h4>{{ insurer.orgId }}  </h4>
                                <p><span class="gray-text fs-12">Admin Insurer :</span> {{ insurer.tradingName }}</p>
                            </div>
                        </div>
                    </div>
            }


        </form>
    </section>
    <section mat-dialog-actions class="d-flex justify-content-end">
        <div class="d-flex gap-2">
            <button class="secondaryBtn" (click)="closeDialog()">
                <span class="btnContent">Cancel</span>
            </button>
            <button class="primaryBtn" (click)="onsubmit()" [disabled]=" isSubmitLoading">
                <span class="btnContent">
                    Submit
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"
                        *ngIf="isSubmitLoading">
                        <path fill="none" stroke="#ffffff" stroke-linecap="round" stroke-width="1.5"
                            d="M12 6.99998C9.1747 6.99987 6.99997 9.24998 7 12C7.00003 14.55 9.02119 17 12 17C14.7712 17 17 14.75 17 12">
                            <animateTransform attributeName="transform" attributeType="XML" dur="1.26s" from="0,12,12"
                                repeatCount="indefinite" to="360,12,12" type="rotate" />
                        </path>
                    </svg>
                </span>
            </button>
        </div>
    </section>
</div>